// 3_pages/index.js
// Homepage (body.in-index): initializes the main carousel and product-block
// sliders, marks white banner slides via #white# in image alt, lazy-loads
// carousel videos, moves the footer banner and welcome section, fetches and
// injects the shop-rating ("hodnoceni obchodu") section and turns homepage
// group titles into links.

let allProductsBlocks = document.querySelectorAll(".products-block");
let hodnoceniObchoduAdded = false;

export function init() {
	if (!document.body.classList.contains("in-index")) return;

	if (!window.NAT?.utils?.inicializeSliderElement) {
		console.warn("[NAT] index.js: window.NAT.utils.inicializeSliderElement missing — check load order");
		return;
	}

	const carousel = document.querySelector("#carousel");
	const carouselInner = document.querySelector(".carousel-inner");
	const carouselItems = document.querySelectorAll("#carousel .item");
	window.NAT.utils.inicializeSliderElement(carousel, carouselInner, carouselItems, "carousel-slider", "a");

	carouselItems.forEach((item) => {
		const img = item.querySelector("img");
		const alt = img?.getAttribute("alt") || "";
		if (alt.includes("#white#")) {
			item.classList.add("white");
			img.setAttribute("alt", alt.replace(/#white#/gi, "").trim());
		}
	});

	document.addEventListener("DOMContentLoaded", function () {
		customLazyVideos();
	});

	allProductsBlocks = document.querySelectorAll(".products-block");
	if (allProductsBlocks && allProductsBlocks.length > 0) {
		allProductsBlocks.forEach((block) => {
			const productsBlockItems = block.querySelectorAll(".product");
			window.NAT.utils.inicializeSliderElement(null, block, productsBlockItems, "products-slider", "img");
		});
	}

	footerNatiosBanner();

	hodnoceniObchoduAdded = false;

	welcomeWrapper();

	document.addEventListener("votesWrapLoaded", () => {
		const votesWrap = document.querySelector(".votes-wrap");
		const votesItems = document.querySelectorAll(".votes-wrap .vote-wrap");
		window.NAT.utils.inicializeSliderElement(null, votesWrap, votesItems, "votes-slider", null);
	});

	hodnoceniObchodu();

	homepageGroupTitlesFunc();
}

function customLazyVideos() {
	const lazyVideos = document.querySelectorAll("a.carousel-video-lazy");
	if (!lazyVideos || lazyVideos.length === 0) {
		return;
	}
	// Banner WebM files are AV1; Safari picks them by container type even without
	// AV1 decoding and never falls back to the MP4 source.
	const canPlayAv1 = document.createElement("video").canPlayType('video/webm; codecs="av01.0.08M.08"') !== "";
	lazyVideos.forEach(function (videoLink) {
		const video = videoLink.querySelector("video");
		if (video && !video.classList.contains("loaded")) {
			if (!canPlayAv1) {
				video.querySelectorAll('source[type="video/webm"]').forEach(function (source) {
					video.appendChild(source);
				});
			}
			const sources = video.querySelectorAll("source");
			sources.forEach(function (source) {
				const dataSrc = source.getAttribute("data-src");
				if (dataSrc) {
					source.setAttribute("src", dataSrc);
				}
			});
			// Safari only allows muted autoplay via the property, and older versions
			// (26.0) keep a video that started while display:none paused once shown.
			video.muted = true;
			video.addEventListener("loadeddata", function onLoaded() {
				videoLink.classList.add("loaded");
				video.classList.add("loaded");
				video.removeEventListener("loadeddata", onLoaded);
				const playPromise = video.play();
				if (playPromise) {
					playPromise.catch(function () {});
				}
			});
			video.load();
		}
	});
}

function footerNatiosBanner() {
	const footerBanner = document.querySelector(".footer-banner");

	if (!footerBanner) {
		console.warn("Footer banner not found.");
		return;
	}

	// Move the footer banner after the second products block
	allProductsBlocks = document.querySelectorAll(".products-block");
	if (allProductsBlocks && allProductsBlocks.length >= 2) {
		allProductsBlocks[1].parentElement.insertAdjacentElement("afterend", footerBanner.parentElement);
	} else {
		console.warn("Not enough products blocks to move the footer banner.");
	}
}

function welcomeWrapper() {
	const welcomeSection = document.querySelector(".welcome-wrapper .welcome");
	const welcomeWrapper = document.querySelector(".welcome-wrapper");
	if (welcomeSection) {
		const h1Element = welcomeSection.querySelector("h1");
		const welcomeTexts = welcomeSection.querySelector(".homepage-welcome-texts");
		if (h1Element && welcomeTexts) {
			welcomeTexts.prepend(h1Element);
		}
		const homepageBlogWrapper = document.querySelector(".homepage-blog-wrapper");
		if (homepageBlogWrapper && welcomeWrapper) {
			homepageBlogWrapper.parentNode.insertBefore(welcomeWrapper, homepageBlogWrapper);

			hodnoceniObchodu();
		} else {
			console.warn("Homepage blog not found in the wrapper.");
		}
	}
}

async function hodnoceniObchodu() {
	if (window.NAT.lang === "pl") {
		return; // Skip for Polish language
	}
	if (hodnoceniObchoduAdded) {
		return;
	}

	hodnoceniObchoduAdded = true;
	const hodnoceniObchoduSection = document.createElement("div");
	hodnoceniObchoduSection.className = "hodnoceni-obchodu-section";

	const hodnoceniTitle = document.createElement("h2");
	hodnoceniTitle.className = "hodnoceni-obchodu-title";
	hodnoceniTitle.textContent = window.NAT.translations("verifiedReviews");

	const welcomeWrapper = document.querySelector(".welcome-wrapper");
	if (welcomeWrapper) {
		welcomeWrapper.parentNode.insertBefore(hodnoceniObchoduSection, welcomeWrapper);
	}

	hodnoceniObchoduSection.appendChild(hodnoceniTitle);

	let fetchAddress = window.NAT.translations("shopRatingUrl");
	// isTestEshop is a global set by an inline snippet outside this bundle
	if (isTestEshop) {
		fetchAddress = "/hodnoceni-obchodu.html";
	}

	// Get .content-inner from the address and append it to the hodnoceniObchoduSection
	try {
		const response = await fetch(fetchAddress);
		if (!response.ok) {
			throw new Error("Failed to fetch data from the server.");
		}

		const html = await response.text();
		const parser = new DOMParser();
		const doc = parser.parseFromString(html, "text/html");
		const votesWrap = doc.querySelector(".votes-wrap");
		const numberOfReviews = doc.querySelector("#ratingWrapper .stars-label");
		// Change the number-of-reviews span to a link
		const numberOfReviewsLink = document.createElement("a");
		if (numberOfReviews) {
			numberOfReviewsLink.href = fetchAddress;
			numberOfReviewsLink.classList.add("stars-label-link");
			numberOfReviewsLink.appendChild(numberOfReviews);
		}

		if (votesWrap) {
			hodnoceniObchoduSection.appendChild(numberOfReviewsLink);
			hodnoceniObchoduSection.appendChild(votesWrap);
			console.log("CUSTOM EVENT DISPATCHED: votesWrapLoaded");
			document.dispatchEvent(new CustomEvent("votesWrapLoaded"));
		} else {
			// NOTE: kept from original — the check is for .votes-wrap, but the message says .content-inner
			console.warn("No .content-inner found in the fetched content.");
		}
	} catch (error) {
		console.error("Error fetching or processing hodnoceni obchodu:", error);
	}
}

function homepageGroupTitlesFunc() {
	const homepageGroupTitles = document.querySelectorAll(".homepage-group-title");
	if (!homepageGroupTitles || homepageGroupTitles.length === 0) {
		return;
	}
	let zobrazitVseTexty = [];
	let nejprodavanejsiUrl = "";
	let novinkyUrl = "";
	let akceUrl = "";
	let blogUrl = "";
	if (document.body.classList.contains("cs")) {
		zobrazitVseTexty = [
			"Zobrazit všechny nejprodávanější",
			"Zobrazit všechny novinky",
			"Zobrazit všechny akce",
			"Zobrazit všechny články",
		];
		nejprodavanejsiUrl = "/nejprodavanejsi/";
		novinkyUrl = "/novinky/";
		akceUrl = "/-akce-mesice/";
		blogUrl = "/blog/";
	}
	if (document.body.classList.contains("sk")) {
		zobrazitVseTexty = [
			"Zobraziť všetky najpredávanejšie",
			"Zobraziť všetky novinky",
			"Zobraziť všetky akcie",
			"Zobraziť všetky články",
		];
		nejprodavanejsiUrl = "/najpredavanejsie/";
		novinkyUrl = "/novinky/";
		akceUrl = "/--akcie-mesiaca/";
		blogUrl = "/blog/";
	}
	if (document.body.classList.contains("pl")) {
		zobrazitVseTexty = [
			"Zobacz wszystkie najczęściej kupowane",
			"Zobacz wszystkie nowości",
			"Zobacz wszystkie promocje",
			"Zobacz wszystkie artykuły",
		];
		nejprodavanejsiUrl = "/najczesciej-kupowane/";
		novinkyUrl = "/nowosci/";
		akceUrl = "/promocja-miesiaca/";
		blogUrl = "/blog/";
	}
	const titleUrlMap = [nejprodavanejsiUrl, novinkyUrl, akceUrl, blogUrl];

	homepageGroupTitles.forEach((titleElement, index) => {
		const titleHref = document.createElement("a");
		titleHref.href = titleUrlMap[index] || "#";
		titleHref.classList.add("homepage-group-title-link");
		titleHref.textContent = titleElement.textContent;
		titleElement.innerHTML = titleHref.outerHTML;

		const titleHrefShowAll = document.createElement("a");
		titleHrefShowAll.href = titleUrlMap[index] || "#";
		titleHrefShowAll.classList.add("homepage-group-title-show-all");
		titleHrefShowAll.classList.add("desktop");
		titleHrefShowAll.textContent = zobrazitVseTexty[index] || "Show All";
		titleElement.appendChild(titleHrefShowAll);

		const titleHrefShowAllBottom = titleHrefShowAll.cloneNode(true);
		titleHrefShowAllBottom.classList.remove("desktop");
		titleHrefShowAllBottom.classList.add("mobile");
		if (index !== 3) {
			// Find the next sibling .products-block-wrapper
			let sibling = titleElement.nextElementSibling;
			while (sibling && !sibling.classList.contains("products-slider")) {
				sibling = sibling.nextElementSibling;
			}
			if (sibling) {
				sibling.appendChild(titleHrefShowAllBottom);
			}
		} else {
			const homepageBlogWrapper = document.querySelector(".homepage-blog-wrapper");
			if (homepageBlogWrapper) {
				homepageBlogWrapper.appendChild(titleHrefShowAllBottom);
			}
		}
	});
}
